import { useEffect, useState } from "react";
import { NavLink, Outlet, Link, useLocation } from "react-router-dom";
import { LayoutDashboard, Users, CreditCard, FolderOpen, ShieldCheck, Settings, ArrowLeft, LogOut, Menu } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useFetch, mediaUrl } from "@/admin/ui";
import "@/styles/admin.css";

const NAV = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard, id: "dashboard" },
  { to: "/admin/alumnos", label: "Alumnos", icon: Users, id: "alumnos" },
  { to: "/admin/pagos", label: "Pagos", icon: CreditCard, id: "pagos" },
  { to: "/admin/contenido", label: "Contenido", icon: FolderOpen, id: "contenido" },
  { to: "/admin/accesos", label: "Accesos", icon: ShieldCheck, id: "accesos" },
  { to: "/admin/configuracion", label: "Configuración", icon: Settings, id: "configuracion" },
];

export default function AdminLayout() {
  const { user, signOut } = useAuth();
  const { data: settings } = useFetch("/admin/settings");
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => setOpen(false), [pathname]);
  const name = settings?.academy_name || "Heartmony";
  return (
    <div className="adm" data-testid="admin-layout">
      <aside className={`adm-side ${open ? "open" : ""}`} data-testid="admin-sidebar">
        <div className="adm-brand">
          {settings?.logo_url && <img src={mediaUrl(settings.logo_url)} alt="" data-testid="admin-logo" />}
          <div><span data-testid="admin-academy-name">{name}</span><small>Administración</small></div>
        </div>
        <nav className="adm-nav" aria-label="Administración">
          {NAV.map((n) => (
            <NavLink key={n.id} to={n.to} data-testid={`admin-nav-${n.id}`}><n.icon size={18} strokeWidth={1.8} />{n.label}</NavLink>
          ))}
        </nav>
        <div className="adm-foot">
          <p style={{ margin: "0 0 .6rem", color: "#CBD5E1" }} data-testid="admin-user-email">{user.email}</p>
          <div className="adm-row" style={{ gap: "1rem" }}>
            <Link to="/inicio" data-testid="admin-back-to-app"><ArrowLeft size={14} /> Volver a la app</Link>
            <button onClick={signOut} data-testid="admin-logout"><LogOut size={14} /> Salir</button>
          </div>
        </div>
      </aside>
      {open && <div className="adm-scrim" onClick={() => setOpen(false)} />}
      <div className="adm-main">
        <div className="adm-mtop">
          <button className="adm-btn sm" onClick={() => setOpen(true)} aria-label="Abrir menú" data-testid="admin-menu-toggle"><Menu size={16} /></button>
          {name} · Administración
        </div>
        <main className="adm-page"><Outlet /></main>
      </div>
    </div>
  );
}
